function projectPath(initiativeId) {
  return `/dashboard/owner/proyectos/${encodeURIComponent(String(initiativeId || ""))}`;
}

export function executeOwnerJarvisUi(navigate, ui) {
  if (!ui?.surface || typeof navigate !== "function") return false;
  const token = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const state = { ownerJarvisUi: { ...ui, token } };

  if (ui.surface === "project_pendings" && ui.initiativeId) {
    try {
      window.dispatchEvent(new CustomEvent("owner:open-project-pendings", {
        detail: { initiativeId: String(ui.initiativeId), projectName: String(ui.projectName || ""), token },
      }));
      return true;
    } catch {
      navigate(projectPath(ui.initiativeId), { state });
      return true;
    }
  }
  if (ui.surface === "project360" && ui.initiativeId) {
    navigate(projectPath(ui.initiativeId), { state });
    return true;
  }
  if (ui.surface === "client" && ui.clientId) {
    navigate(`/dashboard/owner/clientes?cliente=${encodeURIComponent(String(ui.clientId))}`, { state });
    return true;
  }
  if (ui.surface === "owner_home") {
    const allowed = new Set(["finance", "consumption", "client", "proposal", "commitment", "routine", "worklog", "recurring", "interaction", "initiative", "import", "inboxProcess"]);
    const action = allowed.has(String(ui.form || "")) ? String(ui.form) : "";
    navigate(action ? `/dashboard/owner?jarvisAction=${encodeURIComponent(action)}` : "/dashboard/owner", { state });
    return true;
  }
  if (ui.surface === "route" && String(ui.path || "").startsWith("/dashboard/owner")) {
    navigate(String(ui.path), { state });
    return true;
  }
  return false;
}
